var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 480,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m203.5571289 104.0314026-85.5129776-43.1698227-93.8829498 46.8550644 87.8459167 44.1122284zm39.2245789 19.7910385 89.6654663 45.2887039-93.0251617 46.7120514-87.9823761-44.1772461zm119.7662658-62.3174171 92.1283264 46.2116203-82.4067078 41.375946-89.8473816-45.3341675zm-39.6600036-19.9015656-82.9395752-41.6034584-82.0363007 40.9600105 85.4674835 43.0983696zm-64.8349304 357.1943321v113.2022095l100.4658813-50.1503296-.0909729-113.2477112zm100.3293762-89.7194214-.1169434-112.0517883-100.2124328 49.8318482v112.0907898zm120.6175842-20.9869384v113.6376343l-85.7014465 42.7539062-.0714417-113.1112366zm0-39.7380982v-111.3563537l-85.7924194 42.6823883v112.2792511zm-256.4154358-1.4949035-67.6682739-34.0509949v147.0647278l-90.4257736-191.9634705c-.9877663-2.0473175-5.0427856-4.2831573-6.0825348-4.8356171l-58.4079819-29.8068084v259.9159546l60.1625519 32.2506104v-135.9180299l82.7316437 159.1148376c.8513031 1.7223816 9.0263367 18.2896729 17.8252258 24.1132507 11.6776886 7.7669067 61.8196564 37.9182129 61.8196564 37.9182129z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpy);
export default __webpack_public_path__ + "static/media/numpy.a51625a3e1e6b12b6dd5ffd875e3326e.svg";
export { ForwardRef as ReactComponent };